import Base from "./Base";
import axios from "./axios_c";
import Forecast from "@system/config/forecast";
import ResponseMaker from "./ForecastAPICall/responseMaker";
import Helper from "../support/Helper";
import { __remove, __set } from "../store/axios_indicator";

class ForecastAPICall extends Base {
    getForecastData = async (params = {}) => {
        let res = {};
        await this.axiosCall(Forecast.FORECAST_DATA, {
            ...params
        }).then((resHer) => {
            res = resHer.data.data;
        }).catch(e => {
            // res.data = {};
            // res = forecastFakeResponse()
        });
        if (res) {
            let result = await new ResponseMaker(res)
            result = await result.process(params)
            return result.run().get()
        } else {
            return res
        }

    };

    forecastShare = async (params = {}) => {
        let res = {};
        await this.axiosCall(Forecast.FORECAST_SHARE, {
            ...params
        }).then((resHer) => {
            res = resHer.data;
        });

        return res

    };

    getForecastCount = async () => {
        let res = {};
        await this.axiosCall(Forecast.FORECAST_COUNT,{}).then((resHer) => {
            res = resHer?.data?.data;
        }).catch(e => {
            // res.data = {};
            // res = forecastFakeResponse()
        });
        return res;
    };

    downloadForecast = async (params) => {
        let res = {};
        __set('DOWNLOAD_FORECAST_API_CALL')
        await this.axiosCall(Forecast.FORECAST_DOWNLOAD, params, 'post', true, true).then(async (response) => {
            Helper.downloadFileFromRes(response.data,'Forecast_'+Helper.getLongDateFormat(null,true)+'.'+ params.fileType)
            res = response;
            __remove('DOWNLOAD_FORECAST_API_CALL')
        }).catch(e => {
            __remove('DOWNLOAD_FORECAST_API_CALL')
        });
        return res;
    }


    axiosCall = async (url, data = {}, method = 'post', skipParams = false, isBlob = false) => {
        let config = {
            method: method,
            url: url,
            headers: Helper.getCommonHeader(method),
            data: data
        };

        // Set Response Type as Blob 
        if (isBlob) {
            config.responseType = 'blob';
        }

        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        return axios(config);
    };


}

export default ForecastAPICall;